<kendo-splitbutton
  primaryButtons
  (itemClick)="changeJobLogInterval($event)"
  (buttonClick)="downloadJobLogs()"
  [data]="data"
  icon="download"
  look="outline"
  text="Download {{ interval | lowercase }}'s log"
  rounded="full"
></kendo-splitbutton>
